import { render, staticRenderFns } from "./question_list.vue?vue&type=template&id=4e36a81b&scoped=true"
import script from "./question_list.vue?vue&type=script&lang=js"
export * from "./question_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36a81b",
  null
  
)

export default component.exports